import React, { useState } from 'react';
import Menu from '../Menu';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import SuccessMessage from '../../components/successMessage';
import FailedMessage from '../../components/FailedMessage';
import useApiUrls from '../../useApiUrls';

const AddAudio = () => {
  const navigate = useNavigate();
  const { getUrlByOperation } = useApiUrls();

  // State to hold form data
  const [formData, setFormData] = useState({
    name: '',
    remark: '',
    active: true
  });

  // State to hold API response or error
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  // Handle input change
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === 'checkbox') {
      setFormData((prevData) => ({
        ...prevData,
        [name]: checked
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value
      }));
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    
    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      console.error("Missing token or userId");
      setMessage('Authentication failed. Please login again.');
      setIsLoading(false);
      return;
    }
    
    // Match the payload format from your curl command
    const data = {
      name: formData.name,
      remark: formData.remark,
      active: formData.active === 'true' || formData.active === true
    };

    try {
      // Try to get URL from the operation name, or use the direct URL as fallback
      let apiUrl;
      try {
        apiUrl = getUrlByOperation("AudioPackOperation/Insert");
      } catch (e) {
        // Fallback to direct URL
        apiUrl = "https://api.dqr-display-tms.eventum.co.in/api/AudioPackOperation/SubUser/Insert";
      }
      
      const response = await axios.post(
        'https://api.dqr-display-tms.eventum.co.in/api/AudioPackOperation/SubUser/Insert', 
        data,
        {
          headers: {
            'accept': 'text/plain',
            'X-Authorization': token,
            'UserId': userid,
            'Content-Type': 'application/json-patch+json',
          }
        }
      );
      
      if (response.data && response.data.isresponse) {
        setMessage('Audio package added successfully!');
        setTimeout(() => {
          navigate("/audioPackage");
        }, 3000);
      } else {
        const errorMsg = response.data?.errormsg || 'Failed to add audio package.';
        setMessage(errorMsg);
      }
    } catch (error) {
      const errorMsg = error.response?.data?.errormsg || 'Failed to add audio package.';
      setMessage(errorMsg);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Menu />
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1>Add Audio Package</h1>
                </div>
                <div className="col-sm-6">
                  <ol className="breadcrumb float-sm-right">
                    <li className="breadcrumb-item">
                      <a href="#" onClick={(e) => { e.preventDefault(); navigate("/audio"); }}>
                        Audio Packages
                      </a>
                    </li>
                    <li className="breadcrumb-item active">Add Package</li>
                  </ol>
                </div>
              </div>
            </div>
          </section>

          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card card-info">
                    <div className="card-header">
                      <h3 className="card-title">Add Audio Package</h3>
                    </div>
                    <div className="card-body">
                      <form id="add-items" onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Name <span className="text-danger">*</span></label>
                              <input 
                                type="text" 
                                className="form-control" 
                                value={formData.name}
                                onChange={handleChange} 
                                placeholder="Enter package name" 
                                name="name" 
                                required
                              />
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Remark</label>
                              <input 
                                type="text" 
                                className="form-control" 
                                value={formData.remark}
                                onChange={handleChange} 
                                placeholder="Enter remark" 
                                name="remark" 
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Status</label>
                              <select 
                                className="form-control" 
                                name="active" 
                                value={formData.active}
                                onChange={handleChange}
                              >
                                <option value={true}>Active</option>
                                <option value={false}>Inactive</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        
                        <div className="form-footer mt-4">
                          <button 
                            type="submit" 
                            id="add-sub" 
                            className="btn btn-info"
                            disabled={isLoading}
                          >
                            {isLoading ? 'Adding...' : 'Add Package'}
                          </button>
                          <button 
                            type="button" 
                            className="btn btn-default ml-2"
                            onClick={() => navigate("/audio")}
                            disabled={isLoading}
                          >
                            Cancel
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {message === "Audio package added successfully!" ? (
        <SuccessMessage message={message} />
      ) : message ? (
        <FailedMessage message={message} />
      ) : null}
    </>
  );
};

export default AddAudio;

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}